query GetStagesets {
    stagesets(includeEmpty: false) {
        id
        type
        canAccess
        default
        name
        stages {
            id
            name
        }
        isArchived
    }
}
